import { render } from "./LocatorList.vue?vue&type=template&id=118fa869&scoped=true&ts=true"
import script from "./LocatorList.vue?vue&type=script&lang=ts"
export * from "./LocatorList.vue?vue&type=script&lang=ts"

import "./LocatorList.vue?vue&type=style&index=0&id=118fa869&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118fa869"]])

export default __exports__